import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GenerateDocumentApiService } from '../services/document-generation/generate-document-api.service';
import { catchError, map, of } from 'rxjs';

export const documentAccessGuard: CanActivateFn = (route, state) => {
  const documentApi = inject(GenerateDocumentApiService);
  const router = inject(Router);

  const documentId = route.params['id'] || route.queryParams['id'] || route.params['docId'];
  const token = route.queryParams['token'] || route.params['token'];

  // If there's a token, we might be in a public/client view
  if (token) {
    // If it's the proposal-review route, it handles its own validation usually,
    // but we can add logic here if we want to guard it.
    // For now, if a token is present, we assume the backend will validate it upon data fetch.
    return of(true);
  }

  if (!documentId) return of(true);

  // Collaborator endpoint expects numeric CRM document IDs.
  // Uploaded/manual flows can carry UUID-style IDs, which should bypass this check.
  const numericDocumentId = Number(documentId);
  if (!Number.isFinite(numericDocumentId) || numericDocumentId <= 0) {
    return of(true);
  }

  // For internal users, check permissions
  return documentApi.listDocumentCollaborators(numericDocumentId).pipe(
    map(() => true),
    catchError((err) => {
      // Older/local backends may not expose /crm/documents/:id/shares yet.
      // In that case, avoid blocking the route and let the actual document API decide access.
      const status = err?.status;
      if (status === 404 || status === 501) {
        return of(true);
      }
      console.error('Access denied for document:', documentId, err);
      // Redirect to a "No Access" page or dashboard
      router.navigate(['/dashboard/list-proposals']);
      return of(false);
    })
  );
};
